module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('ul', {
    staticClass: "header__menu"
  }), _vm._v(" "), _c('a', {
    staticClass: "logo"
  }, [_vm._v("Numb"), _c('sup', [_vm._v("e")]), _vm._v("r the"), _c('sub', [_vm._v("o")]), _vm._v("R(y)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff95c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 29
// module chunks = 0